import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  margin-bottom: 20px;
  position: relative;

  h4 {
    font-size: 15px;
    color: #000;
    font-weight: bold;
    margin-bottom: 7px;
  }

  table {
    width: 100%;
    border-top: 1px solid #bbb;
    border-bottom: 1px solid #bbb;
  }

  tr {
    border-bottom: 1px solid #e9e9e9;
  }

  tr:last-child {
    border-bottom: none;
  }

  th {
    background-color: #f9f9f9;
    height: 29px;
    padding: 5px;
    border-bottom: 1px solid #d9d9d9;
    text-align: center;
  }

  th.blue {
    background-color: #f1f7ff;
  }

  td {
    height: 29px;
    padding: 5px 5px 3px 5px;
    text-align: center;
  }

  td a {
    color: #002c5f;
    text-decoration: underline;
  }

  &.list_hori {
    margin-bottom: 0;

    th {
      border-bottom: none;
      text-align: left;
      padding: 5px 10px;
    }

    td {
      text-align: left;
      padding: 5px 10px;
    }
  }
`;

const ListWrapDiv = ({ className, children }) => {
  return <StyledDiv className={className}>{children}</StyledDiv>;
};

export default ListWrapDiv;
